export class VesselNotificationMdhAttachment {
    public personTypeId: number = null;
}
